import http from '../../../utils/fetch';
export default {
    getUser() {
        return http({
            url: '/api/swyl/v1/infoCredit/userInfoCredit/getUser',
            method: 'post',
        });
    },
    getCreditList(v) {
        return http({
            url: '/api/swyl/v1/demo/viewTotalmoneyAgent/selectAreaPage',
            method: 'post',
            params: v,
        });
    },
    getcustomeName(){
        return http({
            url: '/api/bscUserInfoAgentBasic/getcustomeName',
            method: 'post',
        });
    },
    selectMoneyCashList(v) {
        return http({
            url: '/api/swyl/v1/infoCredit/viewSellMoneyCredit/selectMoneyCashList',
            method: 'post',
            params: v
        });
    },
    getAgentList() {
        return http({
            url: '/api/bscUserInfoAgentBasic/selectAgentListByArea',
            method: 'post',
        });
    },
    updateCreditUnfreeze(creditId,timeData) {
        return http({
            url: '/api/swyl/v1/infoCredit/userInfoCredit/updateCreditUnfreeze',
            method: 'post',
            params: {creditId,timeData}
        });
    },
    terminateCredit(creditId) {
        return http({
            url: '/api/swyl/v1/infoCredit/userInfoCredit/terminateCredit',
            method: 'post',
            params: {creditId}
        });
    },
    exitCredit(creditId) {
        return http({
            url: '/api/swyl/v1/infoCredit/userInfoCredit/exitCredit',
            method: 'post',
            params: {creditId}
        });
    },
    clearCredit(creditId) {
        return http({
            url: '/api/swyl/v1/infoCredit/userInfoCredit/clearCredit',
            method: 'post',
            params: {creditId}
        });
    },
    isDailishang() {
        return http({
            url: '/api/swyl/v1/infoCredit/userInfoCredit/isDailishang',
            method: 'post',
        });
    },

    synNxSapAccount(v) {
        return http({
            url: '/api/swyl/v1/demo/viewTotalmoneyAgent/synNxSapAccount',
            method: 'post',
            params: v,
        });
    },

    synWxSapAccount(v) {
        return http({
            url: '/api/swyl/v1/demo/viewTotalmoneyAgent/synWxSapAccount',
            method: 'post',
            params: v,
        });
    },

    getSapBom(v) {
        return http({
            url: '/api/swyl/v1/material/manager/Material/getSapBom',
            method: 'post',
            params: v,
        });
    },
}
